import React, { useState } from 'react';
import { useEffect, useRef } from 'react'; 
import styled, { ThemeContext } from 'styled-components'

import timeRedPic from './time-red.png' 
import timeGrayPic from './time-gray.png' 
import types from '../../views/Home/types';
import LotterySegmentTab from '../LotterySegmentTab';
import { secondToMinuteStr } from '../../utils/util';
import theme from '../../theme';
// import { theme } from 'antd';

interface Options {
  text: string;
  fontSize: number;
  fillStyle: string;
  watermarkWidth: number;
  watermarkHeight: number;
  rotate: number;
}

export interface TabProps {
  title: string;
  path: string; 
  minute: string;
  type:number; 
}


const StyledBgWrapper = styled.div`
  background: linear-gradient(90deg,${props=>props.theme.color.primary.main} 0%,${props=>props.theme.color.primary.light} 100%);
  // border-radius: 0 0 50px 50px;
  border-bottom-width: 100px;
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 30px;
`
const StyledWrapper = styled.div`
  width:  100%;
  background: #efefef;
  // box-shadow: 0 .05333rem .10667rem #c5c5da40;
  border-radius: 10px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  overflow: hidden;
  position: relative;
  margin: 3px auto 0;
  display: flex; 
`

const StyledItemWrapper = styled.div`
  flex:1;
  display: flex; 
  boreder-radius: 10px;
  
  flex-direction: column;
  align-items: center;
  // color: gray;
  padding: 10px;
  font-size: 12.8px;
`
const StyledActivteItemWrapper = styled(StyledItemWrapper)` 
  background: white; 
  position: relative;
  // border-style: solid;
  // border-radius: 10px; 
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden; 
  padding: 10px;
  color: black;
`

export function getTypeStr(typeId:number){
  if(typeId==30){
    return '30s'
  }
  
  switch(typeId%4){
    case 1:
      return '1Min'
    case 2:
      return '3Min'
    case 3:
      return '5Min'
    case 0:
      return '10Min'
  } 
}


export const DrawPanelBackground:React.FC = ()=>{
  return <div style={{width:'100%',paddingBottom:'30%',borderTopLeftRadius:10,borderTopRightRadius:30,borderBottomLeftRadius:30,borderBottomRightRadius:10,background:`linear-gradient(90deg,${theme.color.primary.main} 0%,${theme.color.primary.light} 100%)`}}/>
}

export const CountDown:React.FC<{countdown:number}> = ({countdown})=>{
  return <div style={{display:'flex',flexDirection:'row'}}>{secondToMinuteStr(countdown||0).split('').map((i,index)=>{
    // const background = index===0?
    // 'linear-gradient(135deg,transparent .4rem,#fff 0) 0 0':
    // (index===4?'linear-gradient(-45deg,transparent .4rem,#fff 0) 0 0':'white');
    return <div className='digit' style={{background:'transparent',borderRadius:5, marginLeft:5,padding:0,paddingTop:0,paddingBottom:0,fontSize:30, color:(i===':')?'gray':'#e6393b', width:15,textAlign:'center', }}>
      {i} 
      </div>
  })}</div>
}
const LotteryTab: React.FC<{onTabChanged:(tab:TabProps)=>void,tabs:TabProps[],activeTab?:TabProps}> = ({
   onTabChanged,tabs,activeTab
}) => {
  // const [activeItem,setActiveItem] = useState(0)
  // return <div></div>
  return <div style={{position:'relative',width:'100%'}}>
      <StyledBgWrapper/>
    
      {/* <StyledWrapper>    fas
      </StyledWrapper> */}
      <StyledWrapper>   
        {(tabs||[]).map((tab:TabProps,index)=>{
          let typeStr = getTypeStr(tab.type)
        
          if(tab===activeTab){
            return <StyledActivteItemWrapper onClick={()=>{
              // setActiveItem(index)
            }}>
              {/* <img alt='' src={timeRedPic} style={{width:'70%'}}/> */}
              <span>{tab.title} {typeStr}</span>
 
              {/* <span>{tab.title}</span>
              <span>{typeStr}</span> */}
              <div style={{position:'absolute',left:'40%',right:'40%',bottom:5,height:2,background:theme?.color.primary.main,borderRadius:2}}/>
            </StyledActivteItemWrapper>
          }

          return <StyledItemWrapper  onClick={()=>{
            // setActiveItem(index)
            onTabChanged && onTabChanged(tab)
          }}>
            {/* <img alt='' src={timeGrayPic} style={{width:'70%'}}/> */}
            {/* <span>{tab.title}</span>
            <span>{typeStr}</span> */}
            <span>{tab.title} {typeStr}</span>
          </StyledItemWrapper>
          // return <div style={{background:timeRedPic}}>
          //     {JSON.stringify(tab)}
          //   </div>
        
        })}
      </StyledWrapper>
     
    </div>
};

export default LotteryTab;